<template>
  <div class="subtitle-ctn">
    <div class="dot" :class="{'dot--green': green}" />
    <h4 class="subtitle">
      <span v-for="wordObject in titleArr" :class="wordObject.isHighlighted ? 'font-condensed' : 'font-thin'">
        {{ wordObject.word }}
      </span>
    </h4>
  </div>
</template>

<script>
export default {
  name: 'SectionSubtitle',
  data () {
    return {
      titleArr: []
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    green: Boolean,
    highlightedWordIndex: [Array, Number]
  },
  created () {
    const titleArr = this.title.split(' ')
    const wordsArr = titleArr.map((word) => ({ word }))
    if (this.highlightedWordIndex) {
      const highlightIndexArr = Array.isArray(this.highlightedWordIndex) ? this.highlightedWordIndex : [this.highlightedWordIndex]
      highlightIndexArr.forEach(index => { wordsArr[index].isHighlighted = true })
    }
    this.titleArr = wordsArr
  }
}
</script>

<style scoped lang="sass">
@tailwind utilities

.subtitle-ctn
  @apply flex items-center mb-3

.dot
  @apply bg-pink w-2 h-2 mr-2
  &--green
    @apply bg-green-dark

.subtitle
  @apply text-2xl
</style>
